import { jsx as _jsx } from "react/jsx-runtime";
import { MortgageRoot } from "@seeker/mortgage-rate-estimations-mfe";
import { useConfig, useBrand } from "@/contexts/cdpConfig";
import { useRefsContext } from "@/contexts/ref";
import { useMortgage } from "@/hooks";
import { Section } from "@/components/UI";
import { useI18n } from "@/contexts/i18n";
export const MortgageEstimation = () => {
    const brandId = useBrand();
    const { mortgageSectionRef } = useRefsContext();
    const { env } = useConfig();
    const mortage = useMortgage();
    const { t } = useI18n();
    if (!mortage)
        return null;
    const { price, city, id, country, federalStateGeoId, prov, zip, region, originvariant, showMonthlyRateLabel, } = mortage;
    const mortgageSection = "aviv.CDP.Sections.Mortgage";
    return showMonthlyRateLabel ? (_jsx(Section, { ref: mortgageSectionRef, testId: mortgageSection, unsafeClassname: "HideOnPrint", children: _jsx(MortgageRoot, { stage: env, origin: brandId, price: price, city: city, classifiedId: id, country: country, region: region, federalStateGeoId: federalStateGeoId, originvariant: originvariant, prov: prov, zip: zip, 
            // @ts-ignore as the MortageMFE accepts only TFunnction, not CdpTFunction
            t: t }) })) : null;
};
